/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { children, navigate } = this.props;

    if (hasError) {
      return (
        <Box color="secondary.main">
          <Card>
            <CardContent>
              <Typography
                variant="h5"
                component="h2"
                gutterBottom
                color="primary"
              >
                Something went wrong
              </Typography>

              <Typography color="textSecondary">
                {error && error.toString()}
              </Typography>

              <Typography color="textSecondary">
                {errorInfo && errorInfo.componentStack}
              </Typography>

              <Button variant="outlined" onClick={() => navigate(-1)}>
                Go Back
              </Button>
            </CardContent>
          </Card>
        </Box>
      );
    }
    return children;
  }
}

export default function ErrorBoundaryWithHook(props) {
  const navigate = useNavigate();
  return <ErrorBoundary navigate={navigate} {...props} />;
}
